import React from 'react';

export default function ButtonSecondaryWithIcon({className, text, disabled, icon, ...other}) {
	return <button className={` button button--secondary ${className ? className : ''}`} disabled={disabled} {...other}>
		{icon}{text}
	</button>
}
